import md5 from 'md5';

export const getGravatar = (email: string = '', size: number = 32) => {
  const BASE_URL = 'https://www.gravatar.com/avatar';
  const hash = md5(email);
  return `${BASE_URL}/${hash}?size=${size}`;
};
